import React, {useContext} from 'react';
import { Nav, Container, Row, Col } from "react-bootstrap";
import './catpanel.css';
import { observer } from "mobx-react-lite";
import {Context} from "../../index";

const CatPanel = observer(() => {
  const { product } = useContext(Context);

// Прописываем путь до папки с изображениями
const getImagePath = (imageName) => {
    return require(`../../assets/img/CatalogMenu/ImgForCatPanel/${imageName}`);
  };

// Функция для добавления 2 подкатегорий из подкатегорий всех категорий
const addSpecificSubCategories = () => {
    let additionalItems = [];
    let addedCount = 0;

    // Перебираем подкатегории из всех категорий
    product.categories.forEach((category) => {
      if (category.childCatalogs) {
          category.childCatalogs.forEach((childCatalog) => {
          // Условие для выбора 2 подкатегорий (по id или name)
          if (
            (childCatalog.id === 5 || childCatalog.id === 15) && // Выбираем подкатегории по id
            addedCount < 2
          ) {
            additionalItems.push(childCatalog);
            addedCount += 1;
          }
        });
      }
    });

    return additionalItems;
  };

  // Задаем порядок id
const order = [1, 5, 6, 24, 15, 14, 25, 32]; // Ваши id в нужном порядке

// Функция для сортировки категорий по порядку id
const sortCategoriesByOrder = (categories) => {
 return categories.sort((a, b) => {
    const indexA = order.indexOf(a.id);
    const indexB = order.indexOf(b.id);
    return indexA - indexB; // Сортировка по порядку id
  });
};


  // Модифицируем список категорий, добавив подкатегории
  const extendedCategories = [...product.categories, ...addSpecificSubCategories()];

  // Сортируем extendedCategories по порядку
const sortedCategories = sortCategoriesByOrder(extendedCategories);
  
    return (
      <div className="py-0">
      <Container className="mb-4 catpanel">
          <Row>
              {extendedCategories.map((cat, index) => (
                  <React.Fragment key={cat.id || `cat-${index}`}>
                      <Col className={cat.classNameCol}>
                          <div className={cat.classNameDiv} style={{ maxHeight: '200px'}}>
                              <Nav.Link
                                  className="p-4"
                                  style={{ cursor: 'pointer'}}
                                  to={`/catalog/${cat.url}`} // Динамический путь
                                  href={`/catalog/${cat.url}`} // Также добавляем для обычных ссылок
                              >
                                  <h2 className="text-light">{cat.name}</h2>
                                  <img className={cat.classNameImg} src={getImagePath(cat.imageGroup)} alt={cat.name} />
                              </Nav.Link>
                          </div>
                      </Col>

                      {/* Вставляем пустой div между 4 и 5 элементом */  }
                      {(index === 3 || index === 7) && (
                          <div className="d-none d-xl-block w-100" key="divider"></div>
                      )}
                   </React.Fragment>
              ))}
          </Row>
      </Container>
  </div>
    );
});

export default CatPanel;
